import React, {Component} from 'react';
import {Button, Input, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";

class RejectModal extends Component {
  constructor() {
    super();
    this.state={
      response:''
    }
  }

  onChange = e => {
    this.setState({[e.target.name]: e.target.value});
  }

  onSubmit = (order) => {
    const data = {
      id: order.id,
      response: this.state.response
    }
    this.props.rejected(data);
  }
  render() {
    const {isOpen, order, toggle} = this.props
    return (
      <Modal
        isOpen={isOpen}
        toggle={toggle}
      >
        <ModalHeader>
          Reject Order
        </ModalHeader>
        <ModalBody>
          You want to reject the order with IMEI: {order.imei}
          <Input
            type={'textarea'}
            name={'response'}
            onChange={this.onChange}
            value={this.state.response}
          />
        </ModalBody>
        <ModalFooter>
          <Button
            size={'sm'}
            color={'info'}
            onClick={toggle}
          >
            Close
          </Button>

          <Button
            color={'danger'}
            size={'sm'}
            onClick={() => this.onSubmit(order)}
          >
            Reject Order
          </Button>
        </ModalFooter>

      </Modal>
    );
  }
}

export default RejectModal;